import { maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { CortexAgentRunQueryAsyncResult } from "./types";

export const isCortexAgentRunQueryAsyncResult = objectOf<CortexAgentRunQueryAsyncResult>({
  status: number,
  result: maybe(objectOf({ text: string })),
  message: maybe(string),
});
